/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const RotatingArrows16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            d="M13.784 6.089l.07.057 2 2a.5.5 0 01-.638.765l-.07-.057L14 7.706 14 8a6 6 0 01-10.41 4.068l-.216-.246a.5.5 0 01.698-.71l.084.085.016.02a5 5 0 008.824-3L13 8l-.001-.292-1.145 1.146a.5.5 0 01-.638.057l-.07-.057a.5.5 0 01-.057-.638l.057-.07 2-2a.5.5 0 01.638-.057zM8 2c1.7 0 3.285.712 4.41 1.932l.216.246a.5.5 0 01-.698.71l-.084-.085-.016-.02a5 5 0 00-8.824 3L3 8v.293l1.146-1.147a.5.5 0 01.638-.057l.07.057a.5.5 0 01.057.638l-.057.07-2 2a.5.5 0 01-.638.057l-.07-.057-2-2a.5.5 0 01.638-.765l.07.057L2 8.293V8a6 6 0 016-6z"
        />
    </AccessibleSVG>
);

export default RotatingArrows16;
